import { BrowserRouter, Routes, Route } from "react-router-dom";

import UpdatePasswordPage from "./components/UpdatePasswordPage/UpdatePasswordPage";
import LoginPage from "./components/LoginPage/LoginPage";
import ReservationPage from "./components/ReservationPage/ReservationPage";
import UserPage from "./components/UserPage/UserPage";
import ProblemPage from "./components/ProblemPage/ProblemPage";
import MessagePage from "./components/MessagePage/MessagePage";
import AnnouncementPage from "./components/AnnouncementPage/AnnouncementPage";
import HistoryPage from "./components/HistoryPage/HistoryPage";
import ParkingPage from "./components/ParkingPage/ParkingPage";

import ContextProvider from "./components/common/ContextProvider";
import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import RoomPage from "./components/RoomPage/RoomPage";
import LeasePage from "./components/LeasePage/LeasePage";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "./config/theme";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "./components/ErrorPage/ErrorPage";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

function App() {
  const logVersionNumber = async () => {
    // get backend version
    const res = await fetch(`${process.env.REACT_APP_BACKEND_HOST}/api`);
    const backendVersionNumber = (await res.json()).versionNumber;

    console.log(`前端版本: ${process.env.REACT_APP_VERSION}`);
    console.log(`後端版本: ${backendVersionNumber}`);
  };

  useEffect(() => {
    logVersionNumber();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={theme}>
        <BrowserRouter>
          <ErrorBoundary FallbackComponent={ErrorPage}>
            <ContextProvider>
              <Routes>
                <Route path="/" element={<LoginPage />} />
                <Route path="/reservations" element={<ReservationPage />} />
                <Route
                  path="/update-password"
                  element={<UpdatePasswordPage />}
                />
                <Route path="/members" element={<UserPage />} />
                <Route path="/problems" element={<ProblemPage />} />
                <Route path="/messages" element={<MessagePage />} />
                <Route path="/announcement" element={<AnnouncementPage />} />
                <Route path="/system-log" element={<HistoryPage />} />
                <Route path="/parking" element={<ParkingPage />} />
                <Route path="/room" element={<RoomPage />} />
                <Route path="/contract" element={<LeasePage />} />
              </Routes>
            </ContextProvider>
          </ErrorBoundary>
        </BrowserRouter>
      </ChakraProvider>
      {process.env.REACT_APP_SHOW_REACT_QUERY_DEV_TOOLS === "TRUE" ? (
        <ReactQueryDevtools />
      ) : (
        <></>
      )}
    </QueryClientProvider>
  );
}

export default App;
